import { TriangleAlert } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { IOMMU_OFF_WORD, iommuOff } from '@/domain/node'

// 펌웨어의 IOMMU 가 꺼진 노드의 경고(#249). 목록 타일과 상세 제목 줄이 같은 아이콘·같은 문장을 쓴다. 조건이 아니면 아무것도 그리지 않는다.
export function IommuWarning({ failedChecks }: { failedChecks: readonly string[] }) {
  if (!iommuOff(failedChecks)) return null
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span role="img" aria-label={IOMMU_OFF_WORD} className="inline-flex flex-none text-warn-ink">
          <TriangleAlert className="size-4" />
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-xs">{IOMMU_OFF_WORD}</TooltipContent>
    </Tooltip>
  )
}
